import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BudgetPlannerCategoryModalPage } from './budget-planner-category-modal.page';

const routes: Routes = [
  {
    path: '',
    component: BudgetPlannerCategoryModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BudgetPlannerCategoryModalPageRoutingModule {}
